<template>
  <div
    class="row justify-content-sm-center justify-content-xs-center justify-content-end cover min-vh-100"
>
    <div class="col-md-7 d-none d-md-flex justify-content-end flex-column p-5">
        <div class="catchphrase">
            <h3>Voor de mensen die de club runnen</h3>
            <p>Jouw plek voor advies, aankoop en verbetering. Clubcows ontlast en versterkt de club.</p>
        </div>
    </div>
    <div
        class="col-md-5 col-sm-12 justify-content-center align-items-center d-flex flex-column"
    >
        <div class="content w-100 p-5 d-flex flex-column justify-content-center align-items-center">
          <div class="inner">
            <img 
                src="https://clubcows.com/storage/app/public/logo.svg" 
                alt="ClubCows Logo" 
                class="mb-4" 
                style="max-height: 40px;"
            >
            <h3
                style="font-weight: bold;"
            >{{ title }}</h3>
            <router-view />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.row .content {
    background-color: #ffffff;
    height: 100%;

    @media(max-width: 768px) {
        height: auto;
        max-width: 400px;
    }
}

.catchphrase {
    color: #ffffff;

    h3 {
        font-weight: bold;
        color: #fff;
        font-size: 60px;
    }

    p {
        font-family: 'Inter', sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0;
    }
}

.inner {
  width: 100%;
  max-width: 400px;
}

</style>